module.exports = __webpack_public_path__ + "static/media/footerMexico.5ae5cd68.png";